<ul role="menu">
  <ng-container *ngFor="let item of menuItems">
    <li *ngIf="item.isVisible$ | async" [class.destructive]="item.isDestructive" role="menuitem">
      <button [attr.data-test-id]="item.dataTestId" (click)="item.handler()">
        {{ item.label }}
      </button>
    </li>
  </ng-container>
</ul>
